module.exports = __webpack_public_path__ + "img/purchase.e9219953.png";